import {Component, Input, OnInit} from '@angular/core';
import {RegisterForm} from '@app/sign-in/register/@form/register-form';

@Component({
  selector: 'app-email-field[registerForm][showValidation]',
  templateUrl: './email-field.component.html',
  styleUrls: ['./email-field.component.scss']
})
export class EmailFieldComponent implements OnInit {
  @Input() registerForm!: RegisterForm;
  @Input() showValidation!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  isInvalid(): boolean {
    return this.showValidation && this.registerForm.controls.email.invalid;
  }

}
